import { User } from "@phosphor-icons/react";
import { PickerItemProps } from "../../types";

interface ContactData {
  id: string;
  firstName: string;
  lastName: string;
  email?: string;
  phone_mobile?: string;
  jobTitle?: string;
  tags?: string[] | string;
  company?: { name?: string } | null;
}

export const ContactItem = ({ item, isSelected, onSelect }: PickerItemProps<ContactData>) => {
  const companyName = item.company?.name;
  const tagText = Array.isArray(item.tags)
    ? item.tags.join(", ")
    : item.tags || item.jobTitle;

  const secondaryLineParts = [companyName, tagText].filter(Boolean);
  const tertiaryLineParts = [item.email, item.phone_mobile].filter(Boolean);

  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors hover:bg-brick-secondary-fine ${
        isSelected ? "bg-moss-primary/10 border border-moss-primary/30" : ""
      }`}
    >
      <div className="flex items-start gap-2">
        <User className="h-4 w-4 text-neutral-secondary-mid mt-0.5 shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="font-medium text-neutral-primary truncate">
            {item.firstName} {item.lastName}
          </div>
          {secondaryLineParts.length > 0 && (
            <div className="text-xs text-neutral-secondary-mid truncate">
              {secondaryLineParts.join(" • ")}
            </div>
          )}
          {tertiaryLineParts.length > 0 && (
            <div className="text-xs text-neutral-secondary-mid truncate">
              {tertiaryLineParts.join(" • ")}
            </div>
          )}
        </div>
      </div>
    </button>
  );
};